import { useCallback, useState } from "react";
import { ORDER, SORTING } from "components/job/JobTable/constants";

export interface JobTableSortingAction {
  type?: string;
}

export interface JobTableSortingHook {
  sorting: string;
  order: string;
  onAction: (action?: JobTableSortingAction) => void;
}

export default function useJobTableSorting(): JobTableSortingHook {
  const [sorting, setSorting] = useState(SORTING.UPDATED_AT);
  const [order, setOrder] = useState(ORDER.NORMAL);

  const onAction = useCallback(
    (action: JobTableSortingAction = {}) => {
      const { type } = action;

      if (type === "job-alphabetical") {
        if (sorting !== SORTING.JOB) {
          setSorting(SORTING.JOB);
          setOrder(ORDER.NORMAL);
          return;
        }
        if (order === ORDER.NORMAL) {
          setOrder(ORDER.INVERSE);
          return;
        }
        setOrder(ORDER.NORMAL);
        return;
      }

      if (type === "id-alphabetical") {
        if (sorting !== SORTING.ID) {
          setSorting(SORTING.ID);
          setOrder(ORDER.NORMAL);
          return;
        }
        if (order === ORDER.NORMAL) {
          setOrder(ORDER.INVERSE);
          return;
        }
        setOrder(ORDER.NORMAL);
        return;
      }

      if (type === "price-ascending") {
        setSorting(SORTING.PRICE);
        setOrder(ORDER.NORMAL);
        return;
      }

      if (type === "price-descending") {
        setSorting(SORTING.PRICE);
        setOrder(ORDER.INVERSE);
        return;
      }

      if (type === "name-alphabetical") {
        if (sorting !== SORTING.CUSTOMER) {
          setSorting(SORTING.CUSTOMER);
          setOrder(ORDER.NORMAL);
          return;
        }
        if (order === ORDER.NORMAL) {
          setOrder(ORDER.INVERSE);
          return;
        }
        setOrder(ORDER.NORMAL);
        return;
      }

      if (type === "company-name-alphabetical") {
        if (sorting !== SORTING.COMPANY) {
          setSorting(SORTING.COMPANY);
          setOrder(ORDER.NORMAL);
          return;
        }
        if (order === ORDER.NORMAL) {
          setOrder(ORDER.INVERSE);
          return;
        }
        setOrder(ORDER.NORMAL);
        return;
      }

      if (type === "activity-ascending") {
        setSorting(SORTING.UPDATED_AT);
        setOrder(ORDER.NORMAL);
        return;
      }

      if (type === "activity-descending") {
        setSorting(SORTING.UPDATED_AT);
        setOrder(ORDER.INVERSE);
        return;
      }

      if (type === "created-ascending") {
        setSorting(SORTING.CREATED_AT);
        setOrder(ORDER.NORMAL);
        return;
      }

      if (type === "created-descending") {
        setSorting(SORTING.CREATED_AT);
        setOrder(ORDER.INVERSE);
        return;
      }

      setSorting(SORTING.UPDATED_AT);
      setOrder(ORDER.NORMAL);
    },
    [order, sorting]
  );

  return {
    sorting,
    order,
    onAction,
  };
}
